/*=========================================================================================
  File Name: module-usertax-state.js
  Description: UserTax Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	// companyInfo: {}
	EmailList: [],
	EmailWaitingTotal: 0,
	EmailSpamWaitingTotal: 0,
	EmailTotal: 0,
	widthSize: 500,
	TotalEmailUnRead: 0,
	SpamEmailList: [],
	SpamEmailTotal: 0,
	TrashEmailList: [],
	TrashEmailTotal: 0,
	TotalEmailUnReadV2: 0,
	hasAnyEmail: null
};
